/**
 * Navbar Scroll Handler
 * Handles transparent to glass transition on scroll
 */

class NavbarScrollHandler {
    constructor() {
        this.navbar = document.querySelector('.nav-container');
        this.scrollThreshold = 50; // Pixels to scroll before activating glass effect
        this.isScrolled = false;
        
        if (this.navbar) {
            this.init();
        }
    }
    
    init() {
        // Throttled scroll handler for performance
        let ticking = false;
        
        const handleScroll = () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    this.updateNavbar();
                    ticking = false;
                });
                ticking = true;
            }
        };
        
        // Add scroll event listener
        window.addEventListener('scroll', handleScroll, { passive: true });
        
        // Check initial state
        this.updateNavbar();
        
        console.log('Navbar scroll handler initialized');
    }
    
    updateNavbar() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const shouldBeScrolled = scrollTop > this.scrollThreshold;
        
        if (shouldBeScrolled && !this.isScrolled) {
            // Add glass effect
            this.navbar.classList.add('scrolled');
            this.isScrolled = true;
            console.log('Navbar glass effect activated - scrollTop:', scrollTop);
        } else if (!shouldBeScrolled && this.isScrolled) {
            // Remove glass effect
            this.navbar.classList.remove('scrolled');
            this.isScrolled = false;
            console.log('Navbar glass effect deactivated - scrollTop:', scrollTop);
        }
    }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    new NavbarScrollHandler();
});

// Also handle Turbo navigation if using Turbo.js
if (typeof Turbo !== 'undefined') {
    document.addEventListener('turbo:load', () => {
        new NavbarScrollHandler();
    });
}

// Export for potential external use
if (typeof module !== 'undefined' && module.exports) {
    module.exports = NavbarScrollHandler;
}